import PriceRecurringInfo from '@/datatypes/billing/price-recurring-info';
import BillingProduct from '@/datatypes/billing/product';
import BillingPriceMetadata from '@/datatypes/billing/price-metadata';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default class BillingPrice {
  public id: string;
  public currency: 'aud' | 'eur';
  public billingProductId: string;
  public billingScheme: string;
  public externalId: string;
  public name: string;
  public active: boolean;
  public recurring: PriceRecurringInfo = new PriceRecurringInfo({});
  public unitAmount: number;
  public billingProduct: BillingProduct;
  public metadata: BillingPriceMetadata = new BillingPriceMetadata({});
  public subscriptionScheme = 'legacy';

  constructor(options) {
    this.id = options.id;
    this.billingProductId = options.billingProductId;
    this.billingScheme = options.billingScheme;
    this.currency = options.currency;
    this.externalId = options.externalId;
    this.name = options.name;
    this.active = options.active;
    if (options.recurring) {
      this.recurring = new PriceRecurringInfo(camelcaseKeysDeep(options.recurring));
    } else {
      this.recurring = new PriceRecurringInfo({});
    }
    this.unitAmount = options.unitAmount;
    if (options.metadata) {
      this.metadata = new BillingPriceMetadata(options.metadata);
    }
    if (options.billingProduct) {
      this.billingProduct = new BillingProduct(camelcaseKeysDeep(options.billingProduct));
    } else {
      this.billingProduct = new BillingProduct({});
    }
    if (options.subscriptionScheme) { this.subscriptionScheme = options.subscriptionScheme; }
  }

  public payg() {
    return (this.recurring.usageType === 'metered');
  }
}
